import { useEffect, useState } from 'react';
const SESSION_STORAGE_KEY = 'sensitive-story-accepted';

export const getIsAccepted = () => {
  if (typeof window === 'undefined') return false;

  try {
    return !!sessionStorage[SESSION_STORAGE_KEY];
  } catch {
    return false;
  }
};

export const useIsAcceptedSensitive = () => {
  // NOTE: (@kazutoyo) Explicitly set state in side-effects because of mismatches between server-side and client-side hydration
  const [isSensitiveAccepted, setIsSensitiveAccepted] = useState(false);

  useEffect(() => {
    setIsSensitiveAccepted(getIsAccepted());
  }, []);

  return {
    isSensitiveAccepted,
  };
};
